<template>
  <ContactForm />
</template>

<script>
import ContactForm from '@/components/ContactForm'

export default {
  components: {
    ContactForm
  }
}
</script>

<style lang="scss" scoped></style>
